import React from 'react';
import { useUpgrade } from '../../context/UpgradeContext';

/**
 * Small pine "PRO" pill — tap opens upgrade modal for the gated feature.
 */
const ProBadge = ({ feature = 'strategy_card', className = '' }) => {
  const { openUpgrade } = useUpgrade();

  return (
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        openUpgrade(feature);
      }}
      className={`inline-flex items-center px-1.5 py-0.5 rounded-full bg-pine text-bone-raised font-sans text-[10px] font-semibold uppercase tracking-wide leading-none hover:opacity-90 transition-opacity ${className}`}
      aria-label="Pro feature — upgrade to unlock"
    >
      Pro
    </button>
  );
};

export default ProBadge;
